import { useEffect, useState } from "react";
import useHttpHook from "../../../Hooks/HttpHook";
import { ListWishlist } from "../../../utils/ApiConstant";
import { createObjectForPaginatedResult } from "../../../utils/Helper";
import MainComponentWrapper from "../../Common/MainComponentWrapper";
import Wishlist from "./Wishlist";
import MainPagination from "../../Common/MainPagination";
import { toast } from "react-toastify";
import { showErrorToast } from "../../../utils/notify";

const WishlistList = () => {
  const [loading, sendRequest, error] = useHttpHook();
  const [eventsList, setEventsList] = useState();

  const getEvents = async (page = 1) => {
    const events = await sendRequest(`${ListWishlist}?page=${page}`, {
      method: "post",
    });
    if (page === 1) {
      setEventsList(events);
    } else {
      setEventsList((prevState) =>
        createObjectForPaginatedResult(events, prevState)
      );
    }
  };

  useEffect(() => {
    getEvents();
  }, []);

  useEffect(() => {
    if (error) {
      if (toast.isActive(error) === false) {
        showErrorToast(error);
        if (error === "You are unAuthrised") {
          window.location.href = `${process.env.REACT_APP_MERCH_URL}/login`;
        }
      }
    }
  }, [error]);

  const handleRemoved = (eventId) => {
    setEventsList((prevState) => {
      if (!prevState?.data?.itemsList) {
        return prevState;
      }

      return {
        ...prevState,
        data: {
          ...prevState.data,
          itemsList: prevState.data.itemsList.filter(
            (item) => item.event?.[0]?._id !== eventId
          ),
        },
      };
    });
  };

  return (
    <MainComponentWrapper Loading={loading} errorInfo={error}>
      {eventsList?.data?.itemsList?.length > 0 ? (
        <MainPagination getEventsMethod={getEvents} MainData={eventsList}>
          <div className="event-wishlist-grid" role="list" aria-label="Wishlist events">
            {eventsList.data.itemsList.map(({ event }) => (
              <Wishlist
                key={event?.[0]?._id}
                event={event}
                onRemoved={handleRemoved}
              />
            ))}
          </div>
        </MainPagination>
      ) : eventsList ? (
        <div className="event-wishlist-empty">
          <i className="bi bi-heart" aria-hidden="true"></i>
          <p>Your wishlist is empty.</p>
        </div>
      ) : null}
    </MainComponentWrapper>
  );
};

export default WishlistList;
